import React from 'react';
import { CommunicationIllustrationProps } from '../CommunicationMessage';

// --color-aix-blue--20
const primaryColor = '#b5bcd1';
// --color-aix-red--60
const imageHighLight = '#e7828d';

// Dark mode colors (matching Hello.tsx dark variant)
const darkPrimary = '#8B8CC7';
const darkHighlight = '#28C2D1';

const LightIllustration = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 220 200">
    {/* Decorative background circles */}
    <circle cx="28" cy="38" r="18" fill={primaryColor} opacity="0.15" />
    <circle cx="192" cy="162" r="24" fill={imageHighLight} opacity="0.1" />
    <circle cx="178" cy="32" r="7" fill={primaryColor} opacity="0.2" />
    <circle cx="40" cy="175" r="5" fill={imageHighLight} opacity="0.15" />

    {/* Card shadow */}
    <rect x="38" y="33" width="150" height="145" rx="10" fill="#D8D8D8" opacity="0.4" />

    {/* Main card */}
    <rect x="35" y="30" width="150" height="145" rx="10" fill="#FFF" />

    {/* Card header bar */}
    <path d="M45 30 H175 Q185 30 185 40 V62 H35 V40 Q35 30 45 30 Z" fill={primaryColor} />

    {/* Header content */}
    <rect x="50" y="40" width="55" height="5" rx="2.5" fill="#FFF" opacity="0.85" />
    <rect x="50" y="50" width="35" height="3" rx="1.5" fill="#FFF" opacity="0.5" />

    {/* Form field label */}
    <rect x="50" y="76" width="40" height="4" rx="2" fill="#999" />

    {/* Dropdown field (highlighted - needs action) */}
    <rect x="50" y="86" width="120" height="30" rx="5" fill="#FFF" stroke={imageHighLight} strokeWidth="1.5" />
    <rect x="60" y="99" width="55" height="4" rx="2" fill="#CCC" />

    {/* Dropdown chevron */}
    <path d="M155 97 L160 104 L150 104 Z" fill={imageHighLight} />

    {/* Second form field (faded/inactive) */}
    <rect x="50" y="130" width="40" height="4" rx="2" fill="#DDD" />
    <rect x="50" y="140" width="120" height="25" rx="5" fill="#F8F8F8" stroke="#E8E8E8" strokeWidth="1" />
    <rect x="60" y="150" width="50" height="4" rx="2" fill="#E0E0E0" />

    {/* Mouse pointer cursor */}
    <g transform="translate(158, 92)">
      <path
        d="M0 0 L0 22 L5.5 17 L10 26 L14.5 24 L10 15.5 L17 14 Z"
        fill="#3B3A39"
        stroke="#FFF"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
    </g>

    {/* Small accent ring on dropdown */}
    <circle cx="48" cy="101" r="3" fill="none" stroke={imageHighLight} strokeWidth="1" opacity="0.4" />
  </svg>
);

const DarkIllustration = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 220 200">
    {/* Decorative background circles */}
    <circle cx="28" cy="38" r="18" fill={darkPrimary} opacity="0.15" />
    <circle cx="192" cy="162" r="24" fill={darkHighlight} opacity="0.1" />
    <circle cx="178" cy="32" r="7" fill={darkPrimary} opacity="0.2" />
    <circle cx="40" cy="175" r="5" fill={darkHighlight} opacity="0.15" />

    {/* Card shadow */}
    <rect x="38" y="33" width="150" height="145" rx="10" fill="#1A1A2E" opacity="0.3" />

    {/* Main card */}
    <rect x="35" y="30" width="150" height="145" rx="10" fill="#FFF" />

    {/* Card header bar */}
    <path d="M45 30 H175 Q185 30 185 40 V62 H35 V40 Q35 30 45 30 Z" fill={darkPrimary} />

    {/* Header content */}
    <rect x="50" y="40" width="55" height="5" rx="2.5" fill="#FFF" opacity="0.85" />
    <rect x="50" y="50" width="35" height="3" rx="1.5" fill="#FFF" opacity="0.5" />

    {/* Form field label */}
    <rect x="50" y="76" width="40" height="4" rx="2" fill="#999" />

    {/* Dropdown field (highlighted - needs action) */}
    <rect x="50" y="86" width="120" height="30" rx="5" fill="#FFF" stroke={darkHighlight} strokeWidth="1.5" />
    <rect x="60" y="99" width="55" height="4" rx="2" fill="#CCC" />

    {/* Dropdown chevron */}
    <path d="M155 97 L160 104 L150 104 Z" fill={darkHighlight} />

    {/* Second form field (faded/inactive) */}
    <rect x="50" y="130" width="40" height="4" rx="2" fill="#DDD" />
    <rect x="50" y="140" width="120" height="25" rx="5" fill="#F8F8F8" stroke="#E8E8E8" strokeWidth="1" />
    <rect x="60" y="150" width="50" height="4" rx="2" fill="#E0E0E0" />

    {/* Mouse pointer cursor */}
    <g transform="translate(158, 92)">
      <path
        d="M0 0 L0 22 L5.5 17 L10 26 L14.5 24 L10 15.5 L17 14 Z"
        fill="#FFF"
        stroke={darkPrimary}
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
    </g>

    {/* Small accent ring on dropdown */}
    <circle cx="48" cy="101" r="3" fill="none" stroke={darkHighlight} strokeWidth="1" opacity="0.4" />
  </svg>
);

export const ACTION_NEEDED_ILLUSTRATIONS: CommunicationIllustrationProps = {
  LIGHT: <LightIllustration />,
  DARK: <DarkIllustration />,
};
